<div class="kng-breadcrumb">
  <div class="d-flex p-2 align-items-center">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li
          class="breadcrumb-item"
          *ngFor="let breadcrumb of state.breadcrumbData; let i = index"
        >
          <a
            class="breadcrum-text"
            href="{{ breadcrumb.url }}"
            [ngClass]="{
              'link-breadcrumb': i <= state.breadcrumbData.length - 2,
              'active active-breadcrumb': i === state.breadcrumbData.length - 1
            }"
            (click)="routeToUrl(i)" (keypress)="routeToUrl(i)"
          >
            {{ breadcrumb.label }}
          </a>
          <img
            [hidden]="i === state.breadcrumbData.length - 1"
            class="breadcrumb-arr-icon"
            src="{{ state.breadcrumbIcon.url }}"
            alt=""
          />
        </li>
      </ol>
    </nav>
  </div>
</div>
